import React from "react";
import "./About.css";
import Image1 from '../../../assets/img/about/about-image-01.png'
import Image2 from '../../../assets/img/about/about-image-02.png'
import { TbArrowBadgeRight } from "react-icons/tb";

const About = () => {
  return (
      <main className=''>
        <section id="about" className='about-section section'>
          <div className="container about-container">
            <div className="about-content">
              <h2 className="section-title">
                About Us
              </h2>
              <p className="share__description">
                Welcome to <a href="https://AnjouanGaming.com">AnjouanGaming.com</a> &ndash; Your Gateway to Premier
                Internet Gaming Licensing
                <br/>
                AnjouanGaming.com is the official website of Anjouan Licensing Services Inc., the sole authorized
                license administrator and representative of the Anjouan Gaming Board. We are dedicated to providing
                a streamlined, secure, and efficient licensing process for online gaming operators worldwide.
                <br/>
              </p>

              <ul className='about-list'>
                <li className='about-list-item'>
                  <TbArrowBadgeRight className='about-list-icon'/> Fast processing (as quick as 2-3 weeks in some
                  regions)
                </li>
                <li className='about-list-item'>
                  <TbArrowBadgeRight className='about-list-icon'/> Transparent pricing and no hidden fees
                </li>
                <li className='about-list-item'>
                  <TbArrowBadgeRight className='about-list-icon'/> Access to banking, IBAN, and PSP partners
                </li>
                <li className='about-list-item'>
                  <TbArrowBadgeRight className='about-list-icon'/> Ongoing legal and compliance support
                </li>
              </ul>
            </div>

            <div className="about-img-container">
              <img
                  src={Image1}
                  alt="about-main-img"
              />
            </div>
          </div>

          <div className="about-container  container">
            <div className="about-img-container">
              <img
                  src={Image2}
                  alt="about-main-img"
              />
            </div>
            <div className='about-content'>
              <h2 className='section-subtitle'>Who We Are</h2>
              <p>Anjouan Licensing Services Inc. stands at the forefront of the internet gaming industry, offering
                cutting-edge licensing solutions from the autonomous island of Anjouan. With over two decades of
                experience, we have built a reputation as a trusted and reliable partner for gaming businesses
                seeking to establish a strong, compliant presence in the global market.
              </p>
              <p>As the exclusive licensing authority on Anjouan, we are committed to upholding the highest standards
                of regulatory compliance, transparency, and integrity. Our mission is to empower online gaming
                operators with the legal framework and support they need to succeed in a competitive and dynamic
                industry.
              </p>
            </div>
          </div>

          {/* What We Do Section */}
          <div cla className='about-content container'>
            <h2 className='section-subtitle'>What We Do</h2>
            <p>We specialize in providing comprehensive licensing services for a wide range of internet gaming
              activities, including online casinos, web3 casinos, crypto casinos, sports betting, poker, bingo,
              and more. Our services include:
            </p>
            <ul className='about-list'>
              <li className='about-list-item'>
                <TbArrowBadgeRight className='about-list-icon'/>
                <strong>Gaming License Application & Renewal:</strong> We offer a seamless and modern
                application process, ensuring quick approvals and renewals with minimal hassle while maintaining
                integrity to international standards.
              </li>
              <li className='about-list-item'>
                <TbArrowBadgeRight className='about-list-icon'/>
                <strong>Regulatory Compliance: </strong> We require all applicants meet or exceed all legal
                requirements.
              </li>
            </ul>
          </div>

          {/* Why Choose Anjouan Section */}
          <div className='about-content container' id="why-choose">
            <h2 className='section-subtitle'>Why Choose Anjouan</h2>

            <ul className='about-list'>
              <li className='about-list-item'>
                <TbArrowBadgeRight className='about-list-icon'/>
                <strong>Exclusive Authority:</strong> We are the only authorized administrators of internet
                gaming licenses on Anjouan, giving you direct access to a reputable and recognized licensing
                jurisdiction.
              </li>
              <li className='about-list-item'>
                <TbArrowBadgeRight className='about-list-icon'/>
                <strong>Modern Application Process:</strong> Our licensing process is the most advanced in the
                industry, designed to be fast, efficient, and user-friendly, so you can focus on growing your
                business.
              </li>
              <li className='about-list-item'>
                <TbArrowBadgeRight className='about-list-icon'/>
                <strong>Global Reach:</strong> While based on the island of Anjouan, our services cater to
                gaming operators worldwide, helping them establish and expand their presence in various markets.
              </li>
              <li className='about-list-item'>
                <TbArrowBadgeRight className='about-list-icon'/>
                <strong>Trusted Expertise:</strong> With a wealth of experience and a deep understanding of the
                gaming industry, we are the go-to resource for businesses looking to operate within a secure and
                compliant framework.
              </li>
            </ul>
          </div>

          {/*Our Mission Section*/}
          <div className='about-content container' id="our-mission">
            <h2 className='section-subtitle'>Our Mission</h2>
            <p>
              Our mission is to facilitate the growth and success of the global internet gaming industry by
              providing a robust and reliable licensing framework. We are committed to fostering a transparent,
              fair, and regulated gaming environment where businesses can thrive, and players can enjoy a safe and
              secure gaming experience.
            </p>
          </div>

          {/*AOFA Section*/}
          <div className='about-content container' id="aofa">
            <h2 className='section-subtitle'>Anjouan Offshore Financial Authority</h2>
            <p>The Anjouan Offshore Financial Authority (AOFA) has had a positive history characterized by its
              contribution to economic growth, financial stability, and international cooperation.
            </p>
            <p>The AOFA was established with a vision to promote economic development and attract international
              investment to the island of Anjouan. It was founded on principles of transparency, regulatory
              excellence, and adherence to international standards.
            </p>
          </div>
        </section>

      </main>
  );
};

export default About;
